export default __webpack_public_path__ + "static/media/ISEO CLASS-7 EXAM PATTERN 2026-27.db93d800.pdf";